module.exports = __webpack_public_path__ + "img/back_btn.40f32fb8.svg";